import React, { useState } from 'react';
import clsx from 'clsx';
import { navigate } from 'gatsby';
import { useForm } from 'react-hook-form';

import { saveUser } from '@redux/user/actions';
import { useDispatch } from 'react-redux';

import Form from 'react-bootstrap/Form';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import ImgColoredDropShadow from '@common/ImgColoredDropShadow';
import Row from '@common/Row';
import RichText from '@common/RichText';
import Modal from '@common/Modal';
import SmallTitle from '@common/SmallTitle';

import * as styles from './email-signup.module.scss';

const EmailSignup = ({ data }) => {
  const {
    title,
    titleAlignment,
    showTitle,
    text,
    textAlignment,
    listClass,
    showImages,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  const { register, formState: { errors, isValid }, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const onSubmit = (data) => {
    if (isValid) {
      dispatch(saveUser(data));
      navigate('https://get.lillio.com/lillio-academy/');
    }
  };
  return (
    <Section spacing='mt-5 mb-7'>
      <Container>
        <Row className={clsx(`d-flex flex-column align-items-center`, {
            'flex-md-row-reverse': imagePosition === 'Left',
            'flex-md-row': imagePosition === 'Right',
            'justify-content-center': !images
          })}>
          {(text || buttons) &&
            <div className={clsx('col', {'col-lg-10': !images})}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p='mb-3'
                  li='py-2'
                  a='fs-16'
                />
              }
              <Form noValidate onSubmit={handleSubmit(onSubmit)} className={clsx('d-flex flex-column flex-sm-row flex-md-column flex-lg-row mt-3 position-relative', styles.form)}>
                <Form.Group controlId='email' className='mb-2 required'>
                  <Form.Control
                    name='email'
                    type='email'
                    size='lg'
                    required
                    placeholder='email'
                    isInvalid={!!errors.email}
                    className={clsx('fs-20', styles.inputBorder)}
                    {...register('email', { required: 'An E-mail address is required', pattern: /\S+@\S+\.\S+/ })}
                  />
                  <Form.Control.Feedback type='invalid' className={styles.formError}>
                    {errors.email?.message}
                  </Form.Control.Feedback>
                </Form.Group>
                {buttons && buttons[0] &&
                  <Button
                    variant={buttons[0].variant}
                    size={buttons[0].size}
                    addClass={clsx(`mb-2 border border-2 border-dark-grey-4`, buttons[0].addClass)}
                    copy={buttons[0].copy}
                    style={{whiteSpace:'nowrap'}}
                  />
                }
              </Form>
              <p className={clsx('text-center text-sm-start fs-14', {'mt-3':errors.email})}>
                {'Sign up today and get the first week on us! Looking to buy for a team? '}<button className='btn-link' onClick={handleShow}>{'Contact Sales'}</button>
              </p>
              {buttons && buttons[1] && <Modal data={buttons[1].modal} show={show} close={handleClose}/>}
            </div>
          }
          {images &&
            <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx('col text-center', imageWidth, {
                [`d-none ${showImages}`]: showImages,
                'mb-3 mb-md-0': imagePositionTop,
                'mb-lg-5': imagePositionTopLg,
                [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
              })}>
              {images.map(image => (
                <ImgColoredDropShadow
                  key={image.id}
                  image={image}
                  colour={bgColour}
                  direction={imagePosition}
                />  
              ))}
            </div>
          }
        </Row>
      </Container>
    </Section>
  )
}

export default EmailSignup
